//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CycleLayout'
}
